export default {
  CONNECTED: 'connected',
  NOT_AUTHORIZED: 'not_authorized',
  CANCELED: 'canceled',
  UNKNOWN: 'unknown',
};
